<template>
        <el-row class="monitor-header-two" :gutter="20" style="margin-bottom: 20px;">
          <el-col :span="24">
            <div class="monitor-info-name">
              <div class="monitor-cart-name-left">Announcement</div>
               <div class="monitor-cart-name-right" @click="clickMore">More</div>
            </div>
          </el-col>
          <el-col :span="24">
            <div class="Information-table">
                <el-table :data="tableData" :show-header="false" style="width: 100%" @row-click="openNotify" size="mini">
                    <el-table-column class-name="column_cursor">
                        <template slot-scope="scope">
                            <span class="read-color" v-if="scope.row.isRead=='N' ">.</span> <span class="message-title">{{scope.row.title}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column  prop="date" width="90" class-name="column_cursor">
                        <template slot-scope="scope">
                            <span class="message-date">{{scope.row.startTime}}</span>
                        </template>
                    </el-table-column>
                </el-table>

                <notify-dialog
                    ref="notifyDialog"
                    :dialogVisible="dialogVisible"
                    @closeDialog="closeDialog"
                ></notify-dialog>
            </div>
          </el-col>
        </el-row>
       
    
</template>

<script>
import NotifyDialog from './NotifyDialog.vue'
export default {
     components: {
        NotifyDialog
    },
    data(){
        return {
            tableData: [],
            multipleSelection: [],
            dialogVisible:false,
        }
    },
    created(){
        this.getNotifyList()
    },
    methods: {
        openNotify(row, column, event){
            console.log('row',row)

             this.dialogVisible = true
            this.$refs.notifyDialog.setId(row.id,row.isRead)

        },
        closeDialog(){
            this.dialogVisible = false
        },
        getNotifyList() {
            this.$get(`notify/getMyNotifys`).then(({ data: res }) => {
                console.log('getMyNotifys', res.data)

                this.tableData= res.data
            })
        },
        clickMore(){
            console.log('click more')

            this.$router.push({
                path: '/notify/InformationMore'
            })
        }
    }
}
</script>

<style lang="less"  scoped>
.Information-table{
    width: 100%;
    height: 100%;
    padding-bottom: 20px;
    margin-top: 0px;
}
.message-title{
    cursor: pointer;
    font-size: 14px;;
}
.message-date{
    cursor: pointer;
}
.read-color{
    font-size: 40px;
    color: rgb(197, 6, 6);
    cursor: pointer;
}
.monitor-info-name {
  width: 100%;
  height: 50px;
  border-bottom: 1px solid #e6e6e6;
  display: flex;
  justify-content: space-between;
}

.monitor-subtext-map {
  width: 100%;
  /* height: 20px; */
  /* margin-top: -20px; */
  display: flex;
  justify-content: space-between;
  color: #5c5c5c;
  font-size: 14px;
  float: left;
}
.monitor-cart-name-left {
  width: 260px;
  height: 100%;
  /* background: blueviolet; */
  line-height: 42px;
  color: #5c5c5c;
  font-size: 14px;
  font-weight: bold;
  display: flex;
  align-items: center;
}
.monitor-cart-name-left-icon {
  width: 30px;
  height: 30px;
  background: #f7eeff;
  border-radius: 2px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
}
.monitor-cart-name-left-icon-s {
  width: 20px;
  height: 20px;
  color: blueviolet;
  fill: currentColor;
}
.monitor-cart-name-right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-right: 20px;
  cursor: pointer;
}

.monitor-cart-name-right-list {
  width: 60px;
  height: 50px;
  /* background: chartreuse; */
  text-align: center;
  line-height: 50px;
  color: #515a6e;
  font-size: 14px;
  cursor: pointer;
}
.monitor-cart-name-right-list:hover {
  color: #2d8cf0;
}
.monitor-cart-box {
  /*background: chocolate;*/
  width: 100%;
  height: 100px;
  padding: 10px 5px;
  box-sizing: border-box;
  /* border: 1px solid #E6E6E6; */
  background: #ffffff;
  border-radius: 5px;
  margin-bottom: 20px;
}

/deep/.el-table{
  margin-top: 0px !important;
}
/deep/.column_cursor:hover{
  cursor: pointer;
}
</style>